import {
  ANALYTICS_EVENTS,
  EVENT_CLICK_TYPE,
  USER_LOGGED_IN_STATUS
} from '../../../constants/utils/analytics.constant';
import {
  AnalyticsUser,
  ClickEventAnalytics,
  PageLoadErrorAnalytics,
  PageLoadLoginAnalytics
} from '../../../models/utils/analytics.interfaces';

export class LoginStatusAnalyticsHelper {
  static processLoginAnalytics(
    analytics: PageLoadErrorAnalytics | PageLoadLoginAnalytics
  ): PageLoadErrorAnalytics | PageLoadLoginAnalytics {
    const options = {
      [ANALYTICS_EVENTS.PAGE_LOAD_LOGIN]: () => {
        if ((analytics as PageLoadErrorAnalytics).error == undefined) {
          const pageName = (analytics as PageLoadLoginAnalytics).page.info
            .page_name;
          (
            analytics as PageLoadLoginAnalytics
          ).page.info.page_name = `dal:skymiles:${pageName}`;
        }
      },

      [ANALYTICS_EVENTS.ERROR]: () => {
        if ((analytics as PageLoadErrorAnalytics).error.type !== '') {
          const pageName = (analytics as PageLoadErrorAnalytics).page.info
            .page_name;
          (
            analytics as PageLoadErrorAnalytics
          ).page.info.page_name = `dal:${pageName}`;
        }
      }
    };

    const action =
      analytics.event === ANALYTICS_EVENTS.PAGE_LOAD_LOGIN
        ? ANALYTICS_EVENTS.PAGE_LOAD_LOGIN
        : ANALYTICS_EVENTS.ERROR;

    options[action]();
    return analytics;
  }

  static createLoginStatusAnalytics(
    analyticsUser: AnalyticsUser,
    loginPage: string
  ): ClickEventAnalytics {
    const loggedIn = analyticsUser.attributes.is_logged_in;
    const status = this.getLoggedInStatus(loggedIn);
    const eventDetail = `${loginPage}:${status}`;

    return {
      event: ANALYTICS_EVENTS.CLICK,
      event_detail:
        status === USER_LOGGED_IN_STATUS.LOGIN_FAILURE
          ? 'log-in-failure'
          : eventDetail,
      click: {
        name: status,
        type: EVENT_CLICK_TYPE.BUTTON,
        page_section: loginPage,
        action: status
      },
      user: { ...analyticsUser },
      ...(status === USER_LOGGED_IN_STATUS.LOGIN_FAILURE && {
        error: {
          code: 'LOGIN_FAILED',
          message: 'Login authentication failed'
        }
      })
    };
  }

  static getLoggedInStatus(loggedInStatus: string): string {
    return loggedInStatus === USER_LOGGED_IN_STATUS.AUTHENTICATED
      ? USER_LOGGED_IN_STATUS.LOG_IN_SUCCESS
      : USER_LOGGED_IN_STATUS.LOGIN_FAILURE;
  }
}
